import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { CandidateGoodsSearchConditionModel } from '../vo/candidate-goods-search-condition.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

@Injectable()
export class MakeCandidateGoodsFileService extends PlessJsonResponderSub<any> {

  private vo: CandidateGoodsSearchConditionModel;

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof MakeCandidateGoodsFileService
   */
  private getBody(): PlessRequest {
    let searchObj = {
      makeCandidateGoodsFile: {
        parameter: {
          Pcode: this.vo.pcode,
          ItemCode: this.vo.itemCode,
          JANCode: this.vo.janCode,
          MakerName: this.vo.makerName,
          TagSearchType: this.vo.tagSearchType,
          GoodsMarkSearchType: this.vo.goodsMarkSearchType,
          DataKbnFlg: this.vo.dataKbnFlg,
          GoodsDiv: this.vo.goodsDiv,
          BuyerCode: this.vo.buyerCode,
          AdmitStatus: this.vo.admitStatus,
          RegistDateFrom: this.vo.registDateFrom,
          RegistDateTo: this.vo.registDateTo,
          UpdateDateFrom: this.vo.updateDateFrom,
          UpdateDateTo: this.vo.updateDateTo,
          ClassCode: this.vo.classCode,
          MiddleClassCode: this.vo.middleClassCode,
          SmallClassCode: this.vo.smallClassCode,
          OrderClientCode: this.vo.ordrClientCode,
          OrderClientKanji: this.vo.ordrClientKanji,
          PayeeClientCode: this.vo.payeeClientCode,
          PayeeClientKanji: this.vo.payeeClientKanji
        }
      }
    };

    // Pコードリスト
    if (this.vo.pcodeList.length > 0) {
      searchObj["PcodeList"] = {
        combination: this.vo.pcodeList.map(pCode => ({
          parameter: {
            Pcode: pCode
          }
        }))
      };
    }

    // アイテムコードリスト
    if (this.vo.itemCodeList.length > 0) {
      searchObj["ItemCodeList"] = {
        combination: this.vo.itemCodeList.map(itemCode => ({
          parameter: {
            ItemCode: itemCode
          }
        }))
      };
    }

    // タグリスト
    if (this.vo.tagIdList.length > 0) {
      searchObj["TagIdList"] = {
        combination: this.vo.tagIdList.map(tagId => ({
          parameter: {
            TagId: tagId
          }
        }))
      };
    }

    // 商品マークコードリスト
    if (this.vo.goodsMarkCodeList.length > 0) {
      searchObj["GoodsMarkCodeList"] = {
        combination: this.vo.goodsMarkCodeList.map(goodsMarkCode => ({
          parameter: {
            GoodsMarkCode: goodsMarkCode
          }
        }))
      };
    }

    // 生協コードリスト
    if (this.vo.coopCodeList.length > 0) {
      searchObj["CoopCodeList"] = {
        combination: this.vo.coopCodeList.map(coopCode => ({
          parameter: {
            CoopCode: coopCode
          }
        }))
      };
    }

    // デイリーリスト
    if (this.vo.dutiesList.length > 0) {
      searchObj["DutiesList"] = {
        combination: this.vo.dutiesList.map(duties => ({
          parameter: {
            Duties: duties
          }
        }))
      };
    }

    // 商品案内用商品名リスト
    if (this.vo.guideGoodsNameList.length > 0) {
      searchObj["GuideGoodsNameList"] = {
        combination: this.vo.guideGoodsNameList.map(guideGoodsName => ({
          parameter: {
            GuideGoodsName: guideGoodsName
          }
        }))
      };
    }

    // 商品案内用規格名リスト
    if (this.vo.guideStandardNameList.length > 0) {
      searchObj["GuideStandardNameList"] = {
        combination: this.vo.guideStandardNameList.map(guideStandardName => ({
          parameter: {
            GuideStandardName: guideStandardName
          }
        }))
      };
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof MakeCandidateGoodsFileService
   */
  execute(vo: CandidateGoodsSearchConditionModel, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW11makeCandidateGoodsFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof MakeCandidateGoodsFileService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
